import { SectionNavItem, SectionNavSidebar, SectionNavTopBar } from "@components/navigation/SectionNav"
import { PropsWithChildren, ReactNode } from "react"
import { PageTitle } from "./PageTitle"

type Props = PropsWithChildren<{
  title?: ReactNode
  subtitle?: ReactNode
  nav?: SectionNavItem
  navContent?: ReactNode
  mode?: "exact"
}>

export function SidebarLayout(props: Props) {
  return (
    <>
      <SectionNavTopBar nav={props.nav} />
      <div className="pb-8 min-h-[80vh]">
        <div className="grid-auto">
          <div className="hidden sm:block col-span-12 sm:col-span-3">
            <div className="sticky top-headerHeight pt-7 animate-fadeIn">{props.navContent ?? <SectionNavSidebar nav={props.nav} />}</div>
          </div>
          <div className="col-span-12 sm:col-span-9 lg:col-span-6 pt-7">
            {!!props.title && <PageTitle title={props.title} subtitle={props.subtitle} />}
            {props.children}
          </div>
        </div>
      </div>
    </>
  )
}
